module.exports = __webpack_public_path__ + "static/media/pencil01.43760baf.webp";